export default defineAppConfig({
  title: 'Template jamstack'
})
